import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
@Entity('product_conversion_log')
export class ProductConversion {

    @PrimaryGeneratedColumn("increment",{name:'product_conversion_id'})
    productConversionId:number;
    @Column("int",{
        nullable:false,
        name:"to_sale_order"
    })
    toSaleOrder:number;

    @Column("int",{
        nullable:false,
        name:"to_sale_order_item_id"
    })
    toSaleOrderItemId:number;
    @Column("int",{
        nullable:false,
        name:"from_sale_order"
    })
    fromSaleOrder:number;

    @Column("int",{
        nullable:false,
        name:"from_sale_order_item_id"
    })
    fromSaleOrderItemId:number;

    
    @Column("int",{
        nullable:false,
        name:"quantity"
    })
    quantity:number;

    @Column("int",{
        nullable:false,
        name:"boxes"
    })
    boxes:number;

    @Column("int",{
        nullable:false,
        name:"prod_inv_id"
    })
    prodInvId:number;

    @Column("int",{
        nullable:true,
        name:"converted_prod_inv_id",
        default:'0'
    })
    convertedProdInvId:number;

    @Column("int",{
        nullable:false,
        name:"plant_id",
    })
    plantId:number;

    @Column("varchar",{
        nullable:false,
        length:100,
        name:"lot_code"
    })
    lotCode:string;
    @Column("varchar",{
        nullable:false,
        length:100,
        name:"conversion_reason"
    })
    conversionReason:string;
    @Column("varchar",{
        nullable:false,
        length:100,
        name:"from_operation"
    })
    fromOperation:string;
    @Column("varchar",{
        nullable:false,
        length:100,
        name:"to_operation"
    })
    toOperation:string;
    @Column("varchar",{
        nullable:true,
        length:100,
        name:"remarks"
    })
    remarks:string;
    @Column("boolean",{
        nullable:false,
        default:true,
        name:"is_active"
    })
    isActive:boolean;

    @CreateDateColumn({
        name: "created_at",
        type:"datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length:50
    })
    createdUser: string | null;
    @UpdateDateColumn({
        name: "updated_at",
        type:'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length:50
    })
    updatedUser: string | null;

    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;

  
}
